import { render, staticRenderFns } from "./VoicePanel.vue?vue&type=template&id=51dec8b6&scoped=true"
import script from "./VoicePanel.vue?vue&type=script&lang=js"
export * from "./VoicePanel.vue?vue&type=script&lang=js"
import style0 from "./VoicePanel.vue?vue&type=style&index=0&id=51dec8b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dec8b6",
  null
  
)

export default component.exports